import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { useT } from "../i18n/I18nContext";

// Gate for pages that need an authenticated user. While the AuthContext is
// still booting (verifying the stored token via /api/auth/me/), render a
// plain placeholder so protected UI doesn't flash before the redirect
// decision is made.
export default function RequireAuth({ children }) {
  const { status } = useAuth();
  const location = useLocation();
  const t = useT();

  if (status === "loading") {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-bg text-secondText text-sm"
        role="status"
        aria-live="polite"
      >
        {t("auth.loading")}
      </div>
    );
  }

  if (status !== "signedIn") {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return children;
}
